import React from 'react'
import { useTranslation } from 'react-i18next'
import { IoIosArrowForward } from 'react-icons/io'

const Accordion = ({props}) => {
  const { t } = useTranslation()
  const [openCollapse, setOpenCollapse] = React.useState(null)
  return (
    <>
    {props.map(({columns, title}, i) => (
          <div key={`${title}-${i}`} className={`duration-300  ${i === openCollapse ? "text-green-600" : "text-black"} bg-white rounded-xl`} style={{ boxShadow: "0px 0px 10px 0px #0000000D" }}>
            <button 
            className='mobileS:text-base text-left font-bold outline-none my-9 lg:text-4xl duration-500 hover:text-green-600 flex flex-row items-center justify-between w-full p-6'
            onClick={() => i === openCollapse ? setOpenCollapse(null) : setOpenCollapse(i)}>
              {t(title)}
              <IoIosArrowForward size={32} color={i === openCollapse ? "green" : "#000"} className={`${i === openCollapse ? "rotate-90" : "rotate-0"} duration-500`} />
              </button>
            <div className={`relative overflow-y-auto w-full px-6 transition-all duration-500 ${i === openCollapse ? "h-auto opacity-100" : "h-0 opacity-0"}`}>
            <div className={`mx-auto ${i === openCollapse ? "w-[90%] h-[0.3px] bg-[#000]" : "w-0 h-0"}`}/>
            <div className="text-black flex flex-col my-6">
            {columns.map(item => <p>{t(item)}</p>)}
            </div>
            </div>
          </div>
        ))}
    </>
  )
}

export default Accordion